import React, { useEffect, useState } from 'react';
import { ModalContentContext } from '../context/ContentContext';
import { getSiteCoreModalContent } from '../services/sitecoreServices';
import { gtagEnvelope } from '../util/gtagEnvelope';

export const ModalContentProvider = ({ contentId, children }) => {
  const [data, setData] = useState(null);
  useEffect(() => {
    getContent();
  }, []);

  const getContent = () => {
    getSiteCoreModalContent(contentId)
      .then((result) => {
        if (result.status !== 200) {
          setData(false);
        }
        setData(result.data);
      })
      .catch((error) => {
        gtagEnvelope('event', 'trial_page_error', {
          error_type: 'runtime_error',
          error_code: 500,
          error_message: `Trial content loading ${error.message}`,
        });
        setData(false);
      });
  };

  return <ModalContentContext.Provider value={data}>{children}</ModalContentContext.Provider>;
};
